import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useState, useCallback } from 'react';
import { getTransFunc } from '../../Basic/SFxLocalization';
import { IconSettings } from '@sfx/icons';
import webShop from './images/webShop.svg';
import compass from './images/compass.svg';
import { fetchSolutions, getSFxSolutions } from '../utils/checkSFxRoleAuth';
import { initHost } from '../api';
import CommonLoad from '../../Basic/Spin';


var SolutionBar = function SolutionBar(props) {
  var trans = getTransFunc();
  var open = props.open,
      onClose = props.onClose,
      round = props.round,
      footerMenu = props.footerMenu;
  document.body.style.overflow = open ? 'hidden' : 'auto';
  var imgStyle = {
    borderRadius: round ? '6px' : '0'
  };

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      solutions = _useState2[0],
      setSolutions = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      footerMenuList = _useState6[0],
      setTFooterMenuList = _useState6[1];

  var footerMenuGenerator = useCallback(function () {
    var defaultFooterMenu = {
      webShop: {
        isShow: true,
        isMenu: false,
        label: trans('SFxHexagonStore'),
        href: 'https://shop.hexagonmi.com',
        target: '_blank',
        icon: /*#__PURE__*/React.createElement("img", {
          src: webShop
        }),
        onClick: undefined
      },
      discover: {
        isShow: true,
        isMenu: false,
        label: trans('SFxDiscover'),
        href: 'https://www.hexagonmi.com/sfx',
        target: '_blank',
        icon: /*#__PURE__*/React.createElement("img", {
          src: compass
        }),
        onClick: undefined
      },
      accountSetting: {
        isShow: true,
        isMenu: false,
        label: 'Account Settings',
        href: '',
        target: '_self',
        icon: /*#__PURE__*/React.createElement(IconSettings, {
          size: "13",
          style: {
            margin: '0 2px'
          }
        }),
        onClick: function onClick() {
          if (props.accountMenuClick) {
            props.accountMenuClick();
          }

          props.onClose();
        }
      }
    };
    var newMenuList = [];
    var defaultMenuKey = Object.keys(defaultFooterMenu);

    try {
      var newMenu = footerMenu;
      Object.keys(footerMenu).forEach(function (i) {
        defaultMenuKey.forEach(function (j) {
          if (i === j) {
            newMenu[i] = _objectSpread(_objectSpread({}, defaultFooterMenu[j]), footerMenu[i]);
          }
        });
      });
      newMenu = _objectSpread(_objectSpread({}, defaultFooterMenu), newMenu);
      newMenuList = Object.keys(newMenu).map(function (m) {
        return newMenu[m];
      });
    } catch (error) {
      newMenuList = defaultMenuKey.map(function (m) {
        return defaultFooterMenu[m];
      });
    }

    return newMenuList;
  }, [props, footerMenu, trans]);
  useEffect(function () {
    var newMenuList = footerMenuGenerator();
    setTFooterMenuList(newMenuList);
    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [footerMenuGenerator]);
  useEffect(function () {
    if (open) {
      initHost();
      setIsLoading(true);

      var _solutions = getSFxSolutions();

      if (!_solutions.length) {
        fetchSolutions().then(function (solutions) {
          setSolutions(solutions);
          setIsLoading(false);
        });
      } else {
        setSolutions(_solutions);
        setIsLoading(false);
      }
    }
  }, [open]);
  useEffect(function () {
    if (solutions.length) {
      setIsLoading(false);
    }
  }, [solutions]);
  return /*#__PURE__*/React.createElement("div", null, open && /*#__PURE__*/React.createElement("div", {
    className: "sfx-solution-bar-drawer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sfx-solution-bar-my-solution"
  }, trans('SFxSolutionBarTitle')), isLoading && /*#__PURE__*/React.createElement(CommonLoad, {
    size: 0.2
  }), /*#__PURE__*/React.createElement("div", {
    className: "sfx-solution-bar-solutions"
  }, solutions.map(function (s) {
    return /*#__PURE__*/React.createElement("a", {
      key: s.id,
      href: s.url,
      style: {
        textDecoration: 'none'
      },
      title: s.name
    }, /*#__PURE__*/React.createElement("div", {
      className: "sfx-solution-bar-icon-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sfx-solution-bar-icon"
    }, /*#__PURE__*/React.createElement("img", {
      style: imgStyle,
      src: s.img
    }))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "sfx-solution-bar-footer"
  }, footerMenuList.map(function (i, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index
    }, i.isShow && /*#__PURE__*/React.createElement("div", {
      className: "sfx-solution-bar-link-wrap ".concat(i.isMenu ? 'menu-link' : ''),
      onClick: i.onClick
    }, /*#__PURE__*/React.createElement("a", {
      className: "sfx-solution-bar-link",
      href: i.href || undefined,
      target: i.target
    }, /*#__PURE__*/React.createElement("div", {
      className: "sfx-solution-bar-icons"
    }, i.icon), /*#__PURE__*/React.createElement("div", null, i.label))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sfx-solution-bar-filled",
    onClick: onClose
  }));
};

export default SolutionBar;